import type { ID, ReduxAction } from '@repo/utils/types';
import { OrderedMap } from 'immutable';
import AppState from '../app-state';
import Occasion from '@repo/utils/helpers/Occasion';
import { SharedContact } from '@repo/utils/models/SharedContact';
import Collection from '@repo/utils/models/Collection';

export default class SharedContactsCollection extends Collection<SharedContact> {
  page: number;
  hasNext: boolean;
  sharedWithMeContactIds: ID[];

  constructor(props: any = {}) {
    super(props);
    // instead of offset, shared contacts endpoint uses page for pagination
    this.page = props.page || 1;
    this.hasNext = props.hasNext;
    this.sharedWithMeContactIds = props.sharedWithMeContactIds || [];
  }

  get canLoadMore(): boolean {
    return this.hasNext;
  }
}

export type SharedContactsState = SharedContactsCollection;
const initialSharedContactsState = new SharedContactsCollection();

export const selectSharedContact = (uuid: ID) => (state: AppState) =>
  state.sharedData.contacts.items.get(uuid, new SharedContact());

export function sharedContactsReducer(
  state: SharedContactsState = initialSharedContactsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_SHARED_GROUP_SUCCEEDED':
      return state.copyWith({
        items: OrderedMap(
          payload.contacts.map((contact) => [contact.uuid, new SharedContact(contact)]),
        ).merge(state.items),
      });

    case 'FETCH_SHARED_CONTACT_SUCCEEDED':
      const fetchedContactProps = { updated: new Occasion() };
      return state.copyWith({
        items: state.items.update(
          payload.contactUUID,
          new SharedContact({ ...payload.contact, ...payload, ...fetchedContactProps }),
          (contact) => contact.copyWith({ ...payload.contact, ...payload, ...fetchedContactProps }),
        ),
      });

    case 'FETCH_SHARED_CONTACT_FAILED':
      return state.copyWith({
        items: state.items.update(
          payload.contactUUID,
          new SharedContact({ error: payload.error }),
          (contact) => contact.copyWith({ error: payload.error }),
        ),
      });

    default:
      return state;
  }
}
